import { userValidate } from "../../application/dtos/user_validate";

export class userCredentialsEntity {
    constructor({id}){
        this.id = id;
    }

    isValid() {
        return userValidate(this);
    }
}